/* eslint-disable jsx-a11y/anchor-is-valid */
import {FC, useEffect, useRef, useState} from 'react'
import {SearchComponent} from '../../../assets/ts/components'
import {KTIcon} from '../../../helpers'
import {useNavigate} from 'react-router-dom'

// Define routes for search
const availableRoutes = [
  { title: 'داشبورد', path: '/dashboard', icon: 'element-11' },
  { title: 'تسهیلات خط اعتباری', path: '/getall-cardtable-list/1', icon: 'document' },
  { title: 'تسهیلات منابع داخلی', path: '/getall-cardtable-list/2', icon: 'document' },
  { title: 'تسهیلات کارگزاری', path: '/getall-cardtable-list/4', icon: 'document' },
  { title: 'سرمایه گذاری خطر پذیر', path: '/getall-cardtable-list/5', icon: 'document' },
  { title: 'همه کارتابل ها', path: '/getall-cardtable-list/6', icon: 'document' },
  { title: 'ضمانت نامه', path: '/getall-cardtable-list/3', icon: 'document' },
  { title: 'لیست انتظار', path: '/cardtable-waiting-list', icon: 'time' },
  { title: 'بایگانی', path: '/cardtable-archive-list', icon: 'archive' },
  { title: 'همه رونوشت ها', path: '/wrote', icon: 'notepad-bookmark' },
  { title: 'در جریان', path: '/all-request/1', icon: 'update-file' },
  { title: 'تکمیل شده', path: '/all-request/2', icon: 'update-file' },
  { title: 'عودت داده شده', path: '/all-request/3', icon: 'update-file' },
  { title: 'در جریان', path: '/all-supervision/1', icon: 'update-file' },
  { title: 'تکمیل شده', path: '/all-supervision/2', icon: 'update-file' },
  { title: 'عودت داده شده', path: '/all-supervision/3', icon: 'update-file' },
  { title: 'مدیریت پرسنل', path: '/personel-list', icon: 'profile-circle' },
  { title: 'ایجاد برگه نظرسنجی', path: '/survey-category', icon: 'question' },
  { title: 'پشتیبانی', path: '/tickets', icon: 'user' },
  { title: 'مدیریت اشتراک ها', path: '/plans', icon: 'dollar' },
  { title: 'فرم درخواست', path: '/request-form', icon: 'send' },
  { title: 'نامه های دریافتی', path: '/letter', icon: 'message-question' },
  { title: 'گزارش گیری', path: '/letter-3', icon: 'chart' },
  { title: 'سوالات متداول', path: '/faq', icon: 'questionnaire-tablet' },
  { title: 'لیست کاربران', path: '/user-list', icon: 'user-tick' },
  { title: 'تنظیمات CRM', path: '/setting-managment', icon: 'setting-2' }
]

const Search: FC = () => {
  const navigate = useNavigate()
  const [searchVal, setSearchVal] = useState<string>('')
  const [filteredRoutes, setFilteredRoutes] = useState<typeof availableRoutes>([])
  const [menuState, setMenuState] = useState<'main' | 'advanced' | 'preferences'>('main')
  // وضعیت های نمایش را با state مدیریت می‌کنیم
  const [showResults, setShowResults] = useState(false)
  const [showEmpty, setShowEmpty] = useState(false)
  
  const element = useRef<HTMLDivElement | null>(null)
  const wrapperElement = useRef<HTMLDivElement | null>(null)
  const resultsElement = useRef<HTMLDivElement | null>(null)
  const suggestionsElement = useRef<HTMLDivElement | null>(null)
  const emptyElement = useRef<HTMLDivElement | null>(null)
  const searchMenuRef = useRef<any>(null)

  // Filter routes based on search input
  useEffect(() => {
    if (searchVal.length >= 2) {
      const filtered = availableRoutes.filter(route => 
        route.title.toLowerCase().includes(searchVal.toLowerCase())
      )
      setFilteredRoutes(filtered)
      
      // با state مدیریت می‌کنیم
      if (filtered.length > 0) {
        setShowResults(true)
        setShowEmpty(false)
      } else {
        setShowResults(false)
        setShowEmpty(true)
      }
    } else {
      setFilteredRoutes([])
      setShowResults(false)
      setShowEmpty(false)
    }
  }, [searchVal])

  const processs = (search: SearchComponent) => {
    setTimeout(function () {
      // فقط تکمیل جستجو
      search.complete()
    }, 300)
  }

  const clear = (search: SearchComponent) => {
    // Clear search value
    setSearchVal('')
  }

  // Navigate to selected route
  const handleRouteClick = (path: string) => {
    // Store search menu reference
    if (element.current) {
      const menu = document.querySelector('[data-kt-search-element="content"]')
      if (menu) {
        searchMenuRef.current = menu
      }
    }
    
    // Get the search object
    const searchObject = SearchComponent.createInsance('#kt_header_search')
    
    // Navigate to the selected route
    navigate(path)
    
    // Hide the search modal
    if (searchObject) {
      searchObject.hide()
    }
    
    // Reset search after navigation
    setTimeout(() => {
      setSearchVal('')
    }, 100)
  }

  useEffect(() => {
    // Initialize search handler
    const searchObject = SearchComponent.createInsance('#kt_header_search')

    // Search handler
    searchObject!.on('kt.search.process', processs)

    // Clear handler
    searchObject!.on('kt.search.clear', clear)

    return () => {
      // Clean up
      if (searchObject) {
        searchObject.off('kt.search.process', '');
        searchObject.off('kt.search.clear', '');
      }
    }
  }, [])

  return (
    <>
      <div
        id='kt_header_search'
        className='header-search d-flex align-items-center w-100'
        data-kt-search-keypress='true'
        data-kt-search-min-length='2'
        data-kt-search-enter='enter'
        data-kt-search-layout='menu'
        data-kt-search-responsive='false'
        data-kt-menu-trigger='auto'
        data-kt-menu-permanent='true'
        data-kt-menu-placement='bottom-start'
        data-kt-search='true'
        ref={element}
      >
        <form data-kt-search-element='form' className='w-100 position-relative' autoComplete='off'>
          <KTIcon
            iconName='magnifier'
            className='fs-2 search-icon position-absolute top-50 translate-middle-y ms-4'
          />
          <input
            type='text'
            className='search-input form-control ps-13 fs-7 h-40px'
            name='search'
            value={searchVal}
            onChange={(e) => setSearchVal(e.target.value)}
            placeholder='جستجوی سریع'
            data-kt-search-element='input'
          />
        </form>

        <div
          data-kt-search-element='content'
          className='menu menu-sub menu-sub-dropdown p-7 w-325px w-md-375px'
        >
          <div
            className={`${menuState === 'main' ? '' : 'd-none'}`}
            ref={wrapperElement}
            data-kt-search-element='wrapper'
          >
            <form
              data-kt-search-element='form'
              className='w-100 position-relative mb-3'
              autoComplete='off'
            >
              <KTIcon
                iconName='magnifier'
                className='fs-2 text-lg-1 text-gray-500 position-absolute top-50 translate-middle-y ms-0'
              />

              <input
                type='text'
                className='form-control form-control-flush ps-10'
                name='search'
                placeholder='جستجو...'
                value={searchVal}
                onChange={(e) => setSearchVal(e.target.value)}
                data-kt-search-element='input'
              />

              <span
                className='position-absolute top-50 end-0 translate-middle-y lh-0 d-none me-1'
                data-kt-search-element='spinner'
              >
                <span className='spinner-border h-15px w-15px align-middle text-gray-400' />
              </span>

              <span
                className='btn btn-flush btn-active-color-primary position-absolute top-50 end-0 translate-middle-y lh-0 d-none'
                data-kt-search-element='clear'
                onClick={() => setSearchVal('')}
              >
                <KTIcon iconName='cross' className='fs-2 text-lg-1 me-0' />
              </span>
            </form>

            {/* Search Results - با className شرطی */}
            <div 
              ref={resultsElement} 
              data-kt-search-element='results' 
              className={`${showResults ? '' : 'd-none'}`}
            >
              <div className='scroll-y mh-200px mh-lg-350px'>
                <h3 className='fs-5 text-muted m-0 pb-5' data-kt-search-element='category-title'>
                  نتایج
                </h3>

                {filteredRoutes.map((route, index) => (
                  <a
                    key={index}
                    href='#'
                    onClick={(e) => {
                      e.preventDefault()
                      handleRouteClick(route.path)
                    }}
                    className='d-flex text-dark text-hover-primary align-items-center mb-5'
                  >
                    <div className='symbol symbol-40px me-4'>
                      <span className='symbol-label bg-light'>
                        <KTIcon iconName={route.icon} className='fs-2 text-primary' />
                      </span>
                    </div>

                    <div className='d-flex flex-column'>
                      <span className='fs-6 fw-bold'>{route.title}</span>
                    </div>
                  </a>
                ))}
              </div>
            </div>

            {/* Recently Viewed */}
            <div ref={suggestionsElement} className='mb-4' data-kt-search-element='main'>
              <div className='d-flex flex-stack fw-bold mb-4'>
                <span className='text-muted fs-6 me-2'>دسترسی سریع:</span>
              </div>

              <div className='scroll-y mh-200px mh-lg-325px'>
                {availableRoutes.slice(0, 7).map((route, index) => (
                  <div className='d-flex align-items-center mb-5' key={index}>
                    <div className='symbol symbol-40px me-4'>
                      <span className='symbol-label bg-light'>
                        <KTIcon iconName={route.icon} className='fs-2 text-primary' />
                      </span>
                    </div>

                    <div className='d-flex flex-column'>
                      <a
                        href='#'
                        onClick={(e) => {
                          e.preventDefault()
                          e.stopPropagation() // مهم: از انتشار رویداد جلوگیری می‌کند
                          handleRouteClick(route.path)
                        }}
                        className='fs-6 text-gray-800 text-hover-primary fw-bold'
                      >
                        {route.title}
                      </a>
                    </div>
                  </div>
                ))}
              </div>
            </div>

            {/* Empty Results - با className شرطی */}
            <div 
              ref={emptyElement} 
              data-kt-search-element='empty' 
              className={`text-center ${showEmpty ? '' : 'd-none'}`}
            >
              <div className='pt-10 pb-10'>
                <KTIcon iconName='search-list' className='fs-4x opacity-50' />
              </div>

              <div className='pb-15 fw-bold'>
                <h3 className='text-gray-600 fs-5 mb-2'>نتیجه‌ای یافت نشد</h3>
                <div className='text-muted fs-7'>لطفا با کلمات کلیدی دیگری جستجو کنید</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export {Search}